import { AllEnterpriseModule, ModuleRegistry, IntegratedChartsModule, QuickFilterModule, ValidationModule } from 'ag-grid-enterprise'
import { AgChartsCommunityModule } from 'ag-charts-community'

/**
 * Plugin to register AG Grid Enterprise modules globally
 * This ensures modules are registered once at app initialization
 */
export default defineNuxtPlugin(() => {
  // Client-side only plugin (indicated by .client.ts suffix)
  ModuleRegistry.registerModules([
    AllEnterpriseModule,
    QuickFilterModule,
    IntegratedChartsModule.with(AgChartsCommunityModule),
    ValidationModule
  ])
})
